import $ from 'jquery';
import dealerContactOverlay from './dealerContactOverlay.js';
import dealerSearchOverlay from './dealerSearchOverlay.js';
import quoteModal from './quotemodal.js';

(function ($) {
  'use strict';

  //youtube script
  var tag = document.createElement('script');
  tag.src = '//www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  //if Editmode is on
  var isEditMode = $('body').data('iseditmode');

  $(function () {
    dealerContactOverlay.init();
    dealerSearchOverlay.init();
    heroBanners();
    introComponent();
    specificComponent();
    galleryComponent();
    galleryComponentModal();
    specificationComp();
    relatedProductsCompMatchContentHeight();
    tabsComponents();
    testimonialComponent();
    newsEventsCarouselComponent();
    premiumProductsComponent();
    accordionComponent();
    relatedComponent();
    selectDropDownUI();
    customTooltip();
    productListing();
    productRange();
    oddEven();
    brochureDownloadModal();
    quoteDownloadModal();
    regionSelectModal();
    usedEquipmentForm();

    $('#dateofvisit').datepicker({
      minDate: 0,
      dateFormat: 'yy-mm-dd',
    });

    $('form:not([data-form-title="used-equipment"])').on('submit', function () {
      if ($(this).valid()) {
        $(this).find($('input[type="submit"]')).prop('disabled', true);
        $(this).find($('input[type="submit"]')).val('Please wait');
      }
    });
  });

  $(window).on('scroll', function () {
    var $timeline_block = $('#cd-timeline .cd-timeline-block');
    $timeline_block.each(function () {
      if (
        $(this).offset().top <= $(window).scrollTop() + $(window).height() * 0.75 &&
        $(this).find('.cd-timeline-img').hasClass('is-hidden')
      ) {
        $(this)
          .find('.cd-timeline-img, .cd-timeline-content')
          .removeClass('is-hidden')
          .addClass('bounce-in');
      }
    });
  });

  (function sanitizeFormFields() {
    const emailInputs = document.querySelectorAll('input#email');
    const telephoneInputs = document.querySelectorAll('input#telephone');

    [...emailInputs].forEach(function (input) {
      input.addEventListener('keyup', function (e) {
        inputUpdated(e.target, e.target.value);
      });
    });

    [...telephoneInputs].forEach(function (input) {
      input.addEventListener('keyup', function (e) {
        inputUpdated(e.target, e.target.value);
      });
    });

    function inputUpdated(ele, value) {
      if (hasWhiteSpace(value)) {
        const sanitizedValue = sanitizeWhitespace(value);
        ele.value = sanitizedValue;
      }
    }

    function sanitizeWhitespace(value) {
      return value.replace(/ /g, '');
    }

    function hasWhiteSpace(s) {
      return /\s/g.test(s);
    }
  })();

  function oddEven() {
    if ($('.col-md-6.year-item-container').length > 0) {
      $('.container.timelines').each(function () {
        $(this).find('.col-md-6.year-item-container:odd').addClass('odd');
        $(this).find('.col-md-6.year-item-container:even').addClass('even');
      });
    }
  }

  function productRange() {
    var captionWrap = $('.product-range-component').find('figure figcaption');

    if (captionWrap.length > 0) {
      captionWrap.matchHeight();
    }
  }

  /*
      Adds nice hover effect to highlight hovered product and make others opaque
      e.g. https://www.jcb.com/en-gb/products/backhoe-loaders
    */
  function productListing() {
    var productListWrap = $('.product-listing-component-inner');

    productListWrap.each(function (e) {
      var wrap = $(this),
        item = wrap.find('.product-list'),
        editorContentH = wrap.find('.editor-content');

      // product title and desc be same height as each other in each box
      editorContentH
        .matchHeight()
        .promise()
        .done(function () {
          item.matchHeight();
        });

      item.on('mouseenter', function () {
        wrap.addClass('ishovered');
      });
      item.on('mouseleave', function () {
        wrap.removeClass('ishovered');
      });
    });
  }

  function premiumProductsComponent() {
    var relAttOuter = $('.premium-products-component--outer');

    relAttOuter.each(function () {
      var rAOuter = $(this),
        sliderWrap = rAOuter.find('.premium-products-component--items'),
        sliderItems = sliderWrap.find('.premium-products-component--item'),
        customNavWrap = rAOuter.find('.js--premium-products-component--header--nav');

      if (sliderItems.length) {
        sliderWrap.owlCarousel({
          items: 1,
          loop: false,
          autoplay: true,
          mouseDrag: true,
          navContainer: customNavWrap,
          nav: true,
          navText: '',
          dots: false,
          autoHeight: true,
          autoHeightClass: 'owl-height',
          video: true,
          videoWidth: false,
          videoHeight: false,
          lazyLoad: false,
          margin: 30,
          stagePadding: 0,
          responsive: {
            0: {
              margin: 20,
            },
            575: {
              items: 2,
            },
            768: {
              items: 2,
              margin: 30,
            },

            920: {
              items: 2,
              margin: 80,
            },
            1024: {
              items: 3,
              margin: 50,
            },
          },
        });
      }
    });
  }

  function newsEventsCarouselComponent() {
    var relAttOuter = $('.news-events-carousel-component--outer');

    relAttOuter.each(function () {
      var rAOuter = $(this),
        sliderWrap = rAOuter.find('.news-events-carousel-component--items'),
        sliderItems = sliderWrap.find('.news-events-carousel-component--item'),
        customNavWrap = rAOuter.find('.js--carousel-component--header--nav');

      if (sliderItems.length) {
        sliderWrap.owlCarousel({
          items: 1,
          loop: false,
          autoplay: true,
          mouseDrag: true,
          navContainer: customNavWrap,
          nav: true,
          navText: '',
          dots: false,
          autoHeight: true,
          autoHeightClass: 'owl-height',
          video: true,
          videoWidth: false,
          videoHeight: false,
          lazyLoad: false,
          margin: 30,
          stagePadding: 0,
          responsive: {
            0: {
              margin: 20,
            },
            475: {
              items: 2,
            },
            768: {
              items: 3,
              margin: 30,
            },

            920: {
              items: 3,
            },
            1024: {
              items: 4,
            },
          },
        });
      }
    });
  }

  function relatedComponent() {
    var relAttOuter = $('.related-component-outer');

    relAttOuter.each(function () {
      var rAOuter = $(this),
        sliderWrap = rAOuter.find('.related-items'),
        sliderItems = sliderWrap.find('.related-item'),
        customNavWrap = rAOuter.find('#customOwlNavJS');

      if (sliderItems.length) {
        sliderWrap.owlCarousel({
          items: 1,
          loop: true,
          autoplay: false,
          // move navContainer outside the primary owl wrapper
          navContainer: customNavWrap,
          nav: true,
          navText: '',
          dots: false,
          autoHeight: true,
          autoHeightClass: 'owl-height',
          video: true,
          videoWidth: false,
          videoHeight: false,
          margin: 30,
          stagePadding: 30,
          responsive: {
            0: {
              items: 1,
              stagePadding: 30,
              margin: 0,
              loop: true,
            },
            567: {
              items: 1,
              stagePadding: 100,
              margin: 20,
              loop: true,
            },
            750: {
              items: 1,
              stagePadding: 150,
              margin: 20,
              loop: true,
            },
            992: {
              items: 2,
              stagePadding: 0,
              margin: 30,
              loop: false,
            },
          },
        });
      }
    });
  }

  function accordionComponent() {
    var accrodionOuter = $('.accordion-component-outer');

    accrodionOuter.each(function () {
      var aWrap = $(this),
        accordionWrap = aWrap.find('.accordion-items');

      accordionWrap.accordion({
        active: aWrap.hasClass('is-mrrp') ? 0 : 0,
        collapsible: true,
        autoHeight: false,
        heightStyle: 'content',
      });
    });
  }

  function testimonialComponent() {
    var tWrap = $('.testimonial-component-outer');

    tWrap.each(function () {
      var oWrap = $(this),
        sliderWrap = oWrap.find('.testimonial-items'),
        item = sliderWrap.find('.testimonial-item');
      if (item.length) {
        sliderWrap.owlCarousel({
          items: 1,
          loop: false,
          mouseDrag: false,
          autoplay: false,
          dots: true,
          dotClass: 'flat-dot',
          autoHeight: true,
          autoHeightClass: 'owl-height',
          video: true,
          videoWidth: false,
          videoHeight: false,
        });
      } else {
        sliderWrap.removeClass('owl-carousel');
      }
    });
  }

  function relatedProductsCompMatchContentHeight() {
    var comp = $('.related-products-component'),
      compContent = comp.find('.content-wrap');

    if (compContent.length) {
      compContent.matchHeight({
        byRow: true,
        property: 'height',
      });
    }
  }

  function specificationComp() {
    var sComp = $('.specific-component-inner'),
      sheader = sComp.find('.spec-header');

    if (sheader.length) {
      sheader.matchHeight({
        byRow: true,
        property: 'height',
      });
    }
  }

  // TODO: extract into own tabs - components.js file
  function tabsComponents() {
    var tabsWrap = $('.tabs-components-inner .tabs-wrap');
    if (tabsWrap.length) {
      $(tabsWrap).each(function () {
        $(this).tabs();
      });
    }
  }

  function openAnotherTab(url) {
    var fullUrl = window.location.protocol + '//' + window.location.hostname + url;
    window.open(fullUrl, '_blank', 'noopener');
  }

  function populateModalFormSalesforceField(fieldName, product = null, range = null) {
    const salesForceField = document.getElementById(fieldName);
    var formRangeNameField = [...document.getElementsByClassName('js-range-name')];
    var formProductNameField = [...document.getElementsByClassName('js-product-name')];
  
    if (salesForceField && range) {
      salesForceField.value = range;
      formRangeNameField.forEach(field => field.value = range);
    }

    if (salesForceField && product && range) {
      salesForceField.value = range + ';' + product;
      formRangeNameField.forEach(field => field.value = range);
      formProductNameField.forEach(field => field.value = product);
    }
  }

  function getSkipButton(name) {
    var skipButton = document.getElementById('formSkip');
    if (skipButton) {
      skipButton.classList.add(name);
    }

    return skipButton;
  }

  function setupSkipButtonForBrochureDownloadModal(name) {
    var skipButton = getSkipButton(name);
    if (skipButton) {
      skipButton.addEventListener('click', skipBrochureModalForm);
    }

    return skipButton;
  }

  function brochureDownloadModal() {
    $('#brochureDownloadModal .js-close-modal').on('click', function (e) {
      e.preventDefault();
      closeModal($(this).data('dismiss'));
    });
    var skipButton = setupSkipButtonForBrochureDownloadModal('brochure-modal');

    $(document).on('click', '.js-modal-brochure', function (e) {
      e.preventDefault();

      var url = $(this).attr('data-url');
      var product = $(this).attr('data-name');
      var range = $(this).attr('data-category-english-name');

      if ($(this).attr('data-ismodalenabled').toLowerCase() === 'true') {
        $('#brochureDownloadModal').attr('data-brochure-url', url);
        populateModalFormSalesforceField('Input-Range-Models-Brochure-Modal', product, range);

        if (skipButton) {
          skipButton.setAttribute('data-url', url);
        }

        openModal('#brochureDownloadModal', $(this).data('name'));

        $('#brochureDownloadModal form').on('submit', function () {
          if ($(this).valid()) {
            if (url) {
              openAnotherTab(url);
            }
          }
        });
      } else {
        if (url) {
          openAnotherTab(url);
        }
      }
    });

    $('.js-modal-form').on('click', function () {
      if ($('#modal-form_' + $(this).data('form')).hasClass('is-active')) {
        $('.modal-form').removeClass('is-active'); // Remove all active classes
      } else {
        $('.modal-form').removeClass('is-active'); // Remove all active classes
        $('#modal-form_' + $(this).data('form')).toggleClass('is-active');
      }
    });

    function openModal(id, name) {
      $('body').addClass('modal-open');
      $(id).addClass('active');
      $(id).removeClass('fade');

      $('.js-productName').each(function () {
        $(this).html(
          $(this)
            .html()
            .replace(/({productName})/g, '<span class="productName">' + name + '</span>'),
        );
      });
    }

    function closeModal(id) {
      $('body').removeClass('modal-open');
      $('#' + id).addClass('fade');

      setTimeout(function () {
        $('#' + id).removeClass('active');

        $('.js-productName').each(function () {
          $(this).find('.productName').replaceWith('{productName}');
        });
      }, 600);
    }
  }

  function quoteDownloadModal() {
    const quoteModalEle = document.getElementById('quoteDownloadModal');

    if (quoteModalEle) {
      quoteModal.bindModal($(document), '.js-modal-quote');
    }
  }

  function skipBrochureModalForm() {
    openAnotherTab($(this).attr('data-url'));
  }

  function galleryComponentModal() {
    $(document).swipebox({
      selector: '.swipebox',
      useCSS: true, // false will force the use of jQuery for animations
      useSVG: true, // false to force the use of png for buttons
      initialIndexOnArray: 0, // which image index to init when a array is passed
      hideCloseButtonOnMobile: false, // true will hide the close button on mobile devices
      removeBarsOnMobile: true, // false will show top bar on mobile devices
      hideBarsDelay: 3000, // delay before hiding bars on desktop
      videoMaxWidth: 1140, // videos max width
      beforeOpen: function () {}, // called before opening
      afterOpen: function () {
        $('body').addClass('swipebox-open');

        const swipeCloseBtn = document.getElementById('swipebox-close');

        swipeCloseBtn.addEventListener('click', (e) => {
          setTimeout(function () {
            $('body').removeClass('swipebox-open');
          }, 250);
        });

        swipeCloseBtn.addEventListener('touchend', (e) => {
          setTimeout(function () {
            $('body').removeClass('swipebox-open');
          }, 250);
        });
      }, // called after opening
      afterClose: null, // called after closing
      loopAtEnd: false, // true will return to the first image after the last image is reached
    });
  }

  function galleryComponent() {
    var galleryItemsWrap = $('.gallery-component-outer');

    galleryItemsWrap.each(function () {
      var outerWrap = $(this),
        itemsWrap = outerWrap.find('.gallery-items'),
        item = itemsWrap.find('.gallery-item');

      if (item.length) {
        // initialise wth total slides count
        itemsWrap.on('initialized.owl.carousel', function (event) {
          var total = event.item.count;
          outerWrap.find('.slider-nav .thumb .total-no-slider').text(total);
        });

        // carousel config
        itemsWrap.owlCarousel({
          items: 1,
          loop: false,
          autoplay: false,
          mouseDrag: false,
          nav: true,
          dots: true,
          dotClass: 'gallery-dots',
          autoHeight: true,
          autoHeightClass: 'owl-height',
          video: true,
          videoWidth: false,
          videoHeight: false,
        });
      } else {
        itemsWrap.removeClass('owl-carousel');
      }

      // On change update current slide text:
      itemsWrap.on('changed.owl.carousel', function (event) {
        var currentItem = event.item.index;
        outerWrap.find('.slider-nav .thumb .current-no-slider').text(currentItem + 1);
      });
    });
  }

  function specificComponent() {
    var specWrap = $('.specific-component-outer');

    specWrap.each(function () {
      var sWrap = $(this),
        toggleWrap = sWrap.find('.toggle-editor-content'),
        toggleContent = toggleWrap.find('.toggle-editor-content-inner'),
        btn = toggleWrap.find('.jcb-btn');

      btn.on('click', function (e) {
        e.preventDefault();
        toggleWrap
          .toggleClass('expand-overlay')
          .promise()
          .done(
            setTimeout(function () {
              toggleContent.slideToggle('fast');
            }, 300),
          );

        $('html, body').animate(
          {
            scrollTop: sWrap.offset().top,
          },
          300,
        );
      });
    });
  }

  function introComponent() {
    var introCompo = $('.intro-component-outer');

    introCompo.each(function () {
      var introWrap = $(this),
        listCompo = introWrap.find('.compo-list-content'),
        listTitle = introWrap.find('.list-title'),
        listItems = introWrap.find('.list-items'),
        listBtn = introWrap.find('.copy-toggle-btn');

      listBtn.on('click', function (e) {
        e.preventDefault();
        var btn = $(this),
          btnTextMore = btn.find('.text-more'),
          btnTextLess = btn.find('.text-less');
        if (listCompo.length) {
          listItems.slideToggle('fast', function () {
            if (listItems.is(':visible')) {
              btn.addClass('open-overlay');
              btnTextMore.hide();
              btnTextLess.show();
            } else {
              btn.removeClass('open-overlay');
              btnTextMore.show();
              btnTextLess.hide();

              $('html, body').animate(
                {
                  scrollTop: introWrap.offset().top,
                },
                300,
              );
            }
          });
          listTitle.slideToggle('fast');
        }
      });
    });
  }

  function heroBanners() {
    // Hero Banner
    var jcbHeroSlider = $('.jcb-hero-outer');

    jcbHeroSlider.each(function () {
      var heroSliderWrap = $(this),
        hSlider = heroSliderWrap.find('.jcb-hero-inner');

      //Is Edit Mode on
      var trueIfNotEditMode = true;
      if (isEditMode === 'True') {
        trueIfNotEditMode = false;
      }

      //Owl Carousel Setting
      if (heroSliderWrap.find('.jcb-hero-item').length > 1) {
        hSlider.owlCarousel({
          items: 1,
          loop: trueIfNotEditMode,
          animateOut: 'fadeOut',
          autoplay: trueIfNotEditMode,
          autoplayTimeout: 5000,
          mouseDrag: trueIfNotEditMode,
          dots: true,
          dotClass: 'jcb-hero-dots',
          autoHeight: true,
          autoHeightClass: 'owl-height',
          video: true,
          videoWidth: false,
          videoHeight: false,
          onInitialized: function (e) {
            heroSliderWrap
              .find('.owl-item.active')
              .find('.owl-video-play-icon')
              .trigger('click', function () {
                heroSliderWrap.find('iframe').attr('src', '');

                var newPara =
                  '?enablejsapi=1&version=3?&autoplay=1&rel=0&theme=light&showinfo=0&disablekb=1&modestbranding=1&hd=1';
                heroSliderWrap.data('id', newPara);
              });
          },
          onTranslated: function (e) {
            var $carousel = $(e.target);
            var $targetSlide = $carousel.find('.jcb-hero-img').eq(e.item.index + 1);
            if ($targetSlide) {
              var targetStyle = $targetSlide.prev('style')[0];
              $(targetStyle).html($(targetStyle).html().replace('/**', '').replace('**/', ''));
            }
            setTimeout(function () {
              heroSliderWrap.find('.owl-item.active .owl-video-play-icon').trigger('click');
            }, 100);
          },
        });
      } else {
        heroSliderWrap.find('.jcb-hero-inner.owl-carousel').removeClass('owl-carousel');
      }
    });
  }

  function selectDropDownUI() {
    //jQuery UI - DropDown Style
    $(function () {
      $('select.jcb-yellow-select').selectmenu({
        classes: {
          'ui-selectmenu-menu': 'jcb-yellow-drop-down',
          'ui-selectmenu-button': 'jcb-yellow-drop-down',
        },
        open: function (event, ui) {
          // this is a fix for Countries (Dealer Locator page) dropdown list not adjusting to the dropdown button width for no clear reason.
          if (event.currentTarget.id === 'Countries-button') {
            const countriesBtnWidth = event.currentTarget.offsetWidth;
            $('#Countries-menu').outerWidth(countriesBtnWidth);
          }
        },
      });
      $('select.jcb-select-bordered').selectmenu({
        classes: {
          'ui-selectmenu-menu': 'jcb-bordered-drop-down',
          'ui-selectmenu-button': 'jcb-bordered-drop-down',
        },
      });
      $('select.jcb-white-select').selectmenu({
        classes: {
          'ui-selectmenu-menu': 'jcb-white-drop-down',
          'ui-selectmenu-button': 'jcb-white-drop-down',
        },
      });

      $('form .form-control').on('selectmenuchange', function (event, ui) {
        if ($(this).closest('form')) {
          $(this).closest('form').valid();
        }
      });
    });
  }

  function customTooltip() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }

  function cookieObserver() {
    const cookieEvent = new CustomEvent('cookieChanged', {
      bubbles: true,
      detail: {
        cookieValue: getCookie('OptanonAlertBoxClosed'),
        checkChange: () => {
          return cookieEvent.detail.cookieValue === getCookie('OptanonAlertBoxClosed')
            ? false
            : (cookieEvent.detail.cookieValue = getCookie('OptanonAlertBoxClosed'));
        },
        listenCheckChange: () => {
          setInterval(() => {
            if (cookieEvent.detail.checkChange()) {
              cookieEvent.detail.changed = true;
              cookieEvent.target.dispatchEvent(cookieEvent);
            } else {
              cookieEvent.detail.changed = false;
            }
          }, 1000);
        },
        changed: false,
      },
    });

    document.addEventListener('cookieChanged', (e) => {
      e.detail.listenCheckChange();
      if (e.detail.changed === true && getCookie('OptanonAlertBoxClosed')) {
        openModal();
      }
    });
    const cookieEventDispatcher = (e) => {
      e.target.dispatchEvent(cookieEvent);
    };

    window.addEventListener('load', cookieEventDispatcher);
  }

  function getCookie(cName) {
    const name = cName + '=';
    const cDecoded = decodeURIComponent(document.cookie);
    const cArr = cDecoded.split('; ');
    let res;
    cArr.forEach((val) => {
      if (val.indexOf(name) === 0) res = val.substring(name.length);
    });
    return res;
  }

  function openModal() {
    window.scrollTo(0, 0);
    $('.region-select-modal-container').addClass('active');
    $('body').addClass('modal-open');
    $('html').addClass('modal-open');
  }

  function closeModal() {
    $('.region-select-modal-container').removeClass('active');
    $('body').removeClass('modal-open');
    $('html').removeClass('modal-open');
  }

  function regionSelectModal() {
    function init() {
      if ($('.region-select-modal-container').length && !isCountryCookieSet()) {
        showRegionSelectModal();
      }
    }

    function showRegionSelectModal() {
      if (getCookie('OptanonAlertBoxClosed')) {
        openModal();
      } else {
        cookieObserver();
      }
    }

    function isCountryCookieSet() {
      if (
        document.cookie.split(';').filter(function (item) {
          return item.indexOf('jcb-selected-region=') >= 0;
        }).length
      ) {
        return true;
      } else {
        return false;
      }
    }

    (function getUserFormDataCookie() {
      const cookieName = 'jcb-userform-data';

      if (isUserFormDataStored()) {
        const userData = getCookieValueAsJSON(cookieName);
        if (userData != null && userData !== undefined) {
          populateUserFormData(userData);
        }
      }
    })();

    function populateUserFormData(data) {
      const forms = document.getElementsByTagName('form');

      [...forms].forEach(function (form) {
        const formFields = form.querySelectorAll('input:not([type="submit"])');

        [...formFields].forEach(function (field) {
          const fieldId = field.getAttribute('id');

          if (fieldId != null && fieldId !== '') {
            data.forEach(function (value) {
              if (value.FieldName.toUpperCase() == fieldId.toUpperCase()) {
                field.value = value.FieldValue;
              }
            });
          }
        });
      });
    }

    function getCookieValueAsJSON(name) {
      var getCookieValues = function (cookie) {
        var cookieArray = cookie.split('=');
        return cookieArray[1].trim();
      };

      var getCookieNames = function (cookie) {
        var cookieArray = cookie.split('=');
        return cookieArray[0].trim();
      };

      var cookies = document.cookie.split(';');
      var cookieValue = cookies.map(getCookieValues)[cookies.map(getCookieNames).indexOf(name)];

      return cookieValue === undefined ? null : JSON.parse(cookieValue);
    }

    function isUserFormDataStored() {
      return (
        document.cookie.split(';').filter(function (item) {
          return item.trim().indexOf('jcb-userform-data=') == 0;
        }).length > 0
      );
    }

    function renderOptions() {
      var selectedRegion = $('.js-region-dropdown').val();
      var options = [];
      var text, value, region, url, isoCode;

      options.push('<option value="">Please select country</option>');

      $('.js-all-countries > option').each(function () {
        text = $(this).text();
        value = $(this).val();
        region = $(this).attr('data-region');
        url = $(this).attr('data-country-url');
        isoCode = $(this).attr('data-country-iso');

        if (selectedRegion == $(this).attr('data-region')) {
          options.push(
            '<option data-region="' +
              region +
              '" data-country-url="' +
              url +
              '" data-country-iso="' +
              isoCode +
              '" value="' +
              value +
              '">' +
              text +
              '</option>',
          );
          document.cookie = `jcb-selected-region=true; domain=${document.domain}; expires=Sun, 16 Jul 3567 06:23:41 GMT`;
        }
      });

      $('.js-country-dropdown').empty().append(options).selectmenu('refresh');
      $('.js-country-dropdown').selectmenu('enable');
      $('.js-country-dropdown').selectmenu('open');
    }

    function countryPreferenceChanged() {
      updateCountryCookie();
      redirectToCountryUrl();
    }

    function updateCountryCookie() {
      document.cookie = `jcb-selected-region=true; domain=${document.domain}; expires=Sun, 16 Jul 3567 06:23:41 GMT`;
    }

    function redirectToCountryUrl() {
      var selectedCountryUrl = $('.js-country-dropdown option:selected').attr('data-country-url');

      var regExp = /www.jcb.*$/;
      var found = selectedCountryUrl.match(regExp);

      if (found) {
        $(location).attr('href', selectedCountryUrl);
      }
    }

    if (document.querySelector('.js-region-dropdown')) {
      $('.js-region-dropdown').selectmenu({
        classes: {
          'ui-selectmenu-menu': 'jcb-yellow-drop-down',
          'ui-selectmenu-button': 'jcb-yellow-drop-down',
        },
        change: function (event, ui) {
          renderOptions();
        },
      });
    }

    if (document.querySelector('.js-country-dropdown')) {
      $('.js-country-dropdown').selectmenu({
        classes: {
          'ui-selectmenu-menu': 'jcb-yellow-drop-down',
          'ui-selectmenu-button': 'jcb-yellow-drop-down',
        },
        change: function (event, ui) {
          closeModal();
          countryPreferenceChanged();
        },
        disabled: true,
      });
    }

    $('.js--close-modal').on('click', function (e) {
      e.preventDefault();
      closeModal();
    });

    init();
  }

  $.validator.setDefaults({
    ignore: "input[type='hidden']:not([data-val='true'])",
  });

  $.validator.addMethod(
    'validCharcters',
    function (value, element) {
      // allow any non-whitespace characters as the host part
      return !/[~`#%^*()/]+/.test(value);
    },
    'Please enter a valid character.',
  );

  $.validator.addMethod(
    'validEmail',
    function (value, element) {
      const inputValidationState = element.dataset.experianValidInput;
      return inputValidationState === 'true';
    },
    'This email is not valid',
  );

  $('[data-experian-valid-input]').on('blur', sendApiRequest);

  function sendApiRequest() {
    const element = $(this);
    const regexPattern = new RegExp(element.attr('data-val-regex-pattern'));
    const regexTestPassed = regexPattern.test(element.val());

    if (regexTestPassed) {
      let data = { email: element.val() };

      // for testing purposes:
      window.mockedConfidenceLevel &&
        (data['mockedConfidenceLevel'] = window.mockedConfidenceLevel);

      element.attr('data-experian-valid-input', 'pending');
      $.ajax({
        url: '/api/experian/validate',
        type: 'POST',
        data: data,
        async: true,
        cache: false,
        error: function () {
          element.attr('data-experian-valid-input', 'true');
          element.valid();
        },
        success: function (result) {
          if (result.isValid) {
            element.attr('data-experian-valid-input', 'true');
            element.valid();
          } else {
            element.attr('data-msg', result.errorMessage);
            element.attr('data-experian-valid-input', 'false');
            element.valid();
          }
        },
      });
    }
  }

  function usedEquipmentForm() {
    //watch the select boxes for change
    $('[data-form-title="used-equipment"] .form-control').on(
      'selectmenuchange',
      function (event, ui) {
        if ($(this).is('select')) {
          var currentSelectElm = $(this);
          var selectedVal = ui.item['value'];

          if (selectedVal != '') {
            currentSelectElm.attr('data-is-selected', true);
          } else {
            currentSelectElm.attr('data-is-selected', false);
          }

          var result = fetchSelectFilterOptions();

          if ($(this).is('#used-price-range')) {
            if (selectedVal != '') {
              $('.js--show-more-used-equipments')
                .attr('data-sort-col', 'price')
                .attr('data-sort-dir', 'asc');
            } else {
              //Reset the Load more attribute
              $('.js--show-more-used-equipments')
                .attr('data-sort-col', 'lastModified')
                .attr('data-sort-dir', 'desc');
            }
          }
        }
      },
    );

    $('[data-form-title="used-equipment"] input[type=checkbox]').on('change', function (event, ui) {
      var currentSelectElm = $(this);

      if (currentSelectElm !== undefined) {
        var result = fetchSelectFilterOptions();
      }
    });

    $('[data-form-title="used-equipment"]').on('submit', function (event) {
      event.preventDefault();
      var usedEquipmentForm = this;

      usedEquipmentForm.querySelector('input[type=submit]').disabled = true;

      function reSetSearchBtn(error) {
        usedEquipmentForm.querySelector('input[type=submit]').disabled = false;

        if (error) {
          usedEquipmentForm.querySelector('input[type=submit]').value = 'Search';
          usedEquipmentForm.querySelector('input[type=submit]').removeAttribute('data-btn-text');
          return;
        }

        usedEquipmentForm.querySelector('input[type=submit]').value = usedEquipmentForm
          .querySelector('input[type=submit]')
          .getAttribute('data-btn-text');
      }

      var lang = $('html').attr('lang');
      var requestURIBase =
        $('#used-price-range').val() != ''
          ? '/api/v1/used/' + lang + '/search' + '/price' + '/asc'
          : '/api/v1/used/' + lang + '/search';
      var formData = $('[data-form-title="used-equipment"]').serializeArray();
      var formDataArry = [];
      jQuery.each(formData, function (i, field) {
        var isSelected = false;
        var optionArray = [];

        if (field.name.indexOf('Form.Fields') !== -1) {
          var fieldElm = $('select[name="' + field.name + '"]');

          if (fieldElm != undefined && fieldElm != null) {
            isSelected = $('select[name="' + field.name + '"]').attr('data-is-selected');
          }

          if (isSelected) {
            var values = jQuery.each(
              $('select[name="' + field.name + '"] option'),
              function (i, option) {
                optionArray.push(option.value);
              },
            );
            field.options = optionArray;
          }
        }

        formDataArry.push({
          isSelected: isSelected != undefined ? isSelected : 'false',
          name: field.name,
          value: field.value,
          options: optionArray,
        });
      });
      // write to storage
      sessionStorage.setItem('jcb-used-formfields', JSON.stringify(formDataArry));
      sessionStorage.setItem('jcb-used-url-path', window.location.pathname);
      resetSortOptions();

      $.ajax({
        type: 'POST',
        url: requestURIBase,
        data: formData,
        success: function (data) {
          renderUsedEquipmentResults(data);
          scrollToUsedEquipmentResults();
          reSetSearchBtn();
        },
        error: function () {
          reSetSearchBtn('error');
        },
      });
    });

    //sort by
    $('.js--used-sortby').on('selectmenuchange', function (e) {
      e.preventDefault();
      sessionStorage.setItem('jcb-used-sortby', $(this).val());
      var order = $(this).val().split('/');
      var limit = $('.js--show-more-used-equipments').data('perpage');
      var lang = $('html').attr('lang');
      var col = order[0];
      var dir = order[1];
      $('.js--show-more-used-equipments').attr('data-sort-col', col).attr('data-sort-dir', dir);

      var requestURIBase =
        '/api/v1/used/' + lang + '/search/' + 0 + '/' + limit + '/' + col + '/' + dir;
      $.ajax({
        type: 'GET',
        url: requestURIBase,
        success: function (data) {
          if (data.length > 0) {
            renderUsedEquipmentResults(data);
          }
        },
      });
    });

    //load more
    $('.js--show-more-used-equipments').on('click', function (e) {
      e.preventDefault();
      var limit = $(this).attr('data-perpage');
      var lang = $('html').attr('lang');
      var count = $('.used-equipment-results--item').length;
      var col = $(this).attr('data-sort-col');
      var dir = $(this).attr('data-sort-dir');
      var requestURIBase =
        '/api/v1/used/' + lang + '/search/' + count + '/' + limit + '/' + col + '/' + dir;
      $('.js--show-more-used-equipments').attr('disabled', true);
      $('.js--show-more-used-equipments').text('Loading...');

      $.ajax({
        type: 'GET',
        url: requestURIBase,
        success: function (data) {
          if (data.length > 0) {
            renderUsedEquipmentResults(data, true);
          }
          $('.js--show-more-used-equipments').attr('disabled', false);
          $('.js--show-more-used-equipments').text(
            $('.js--show-more-used-equipments').attr('title'),
          );
        },
      });
    });

    function watchKeywordSearchInput() {
      let typingTimer;
      let doneTypingInterval = 1000;
      let usedKeywords = $('[data-form-title="used-equipment"]  #used-keywords');

      usedKeywords.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
      });

      //on keydown, clear the countdown
      usedKeywords.on('keydown', function () {
        clearTimeout(typingTimer);
      });

      function doneTyping() {
        fetchSelectFilterOptions();
      }
    }

    function watchKeywordSearchInputDealer() {
      let typingTimer;
      let doneTypingInterval = 1000;
      let usedKeywords = $('[data-form-title="dealer-used-equipment"]  #used-keywords');

      usedKeywords.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
      });

      //on keydown, clear the countdown
      usedKeywords.on('keydown', function () {
        clearTimeout(typingTimer);
      });

      function doneTyping() {
        fetchSelectFilterOptions();
      }
    }

    watchKeywordSearchInput();
    watchKeywordSearchInputDealer();

    //fetches form data from API and then returns an object
    function fetchSelectFilterOptions() {
      var lang = $('html').attr('lang');
      var dealer = $('#used-dealer-search').data('dealer-name');
      var uri;

      if (dealer == null) {
        uri = '/api/v1/used/' + lang + '/search-options';
      } else {
        uri = '/api/v1/used/' + lang + '/' + dealer + '/dealer-search-options';
      }

      const requestURIBase = uri;

      var limit = $('.js--show-more-used-equipments').data('perpage');
      var myForm = document.querySelectorAll('[data-form-title]');

      var formData = $('[data-form-title="used-equipment"]').serializeArray();

      $.ajax({
        type: 'POST',
        url: requestURIBase,
        data: formData,
        success: function (data) {
          populateSelectOptions(data.Fields);
          updateSearchResultValue(data.ResultCount);
          $('.js--show-more-used-equipments').attr('data-total', data.ResultCount).hide();
        },
      });
    }

    function updateSearchResultValue(data) {
      var submitBtn = $('[data-form-title="used-equipment"] :submit');
      var newValue = i18n.UsedSearch.searchButton + ' (' + data + ')';
      submitBtn.attr('value', newValue);
      submitBtn.attr('data-btn-text', newValue);
    }

    function populateSelectOptions(data) {
      var fieldsObj = data;

      for (var i = 0, l = fieldsObj.length; i < l; i++) {
        var obj = fieldsObj[i];
        var objId = obj['Id'];
        var objOptionsArr = obj['Value'];

        $('[data-form-title="used-equipment"] select.form-control').each(function () {
          if ($(this).attr('id') == objId) {
            populateSelect($(this), objOptionsArr, $(this).find(':selected').text());
          }
        });
      }
    }

    //populates the select using the passed options
    function populateSelect(element, options, defaultOption = undefined) {
      var select = element;
      var options = options;

      //grab default option
      var firstOption = $(select).find('option:first');

      //empty select
      $(select).find('option').remove();
      $(select).append(firstOption);

      //Populate select
      $.each(options, function (index, value) {
        if (value !== '') {
          var optionHtml = '<option value="' + value + '">' + value + '</option>';
          if (defaultOption === value) {
            optionHtml = '<option value="' + value + '" selected>' + value + '</option>';
          }

          $(select).append(optionHtml);
        }
      });

      //rebuild the selectmenu
      $(select).selectmenu('refresh');
    }

    //Results

    function renderUsedEquipmentResults(data, append) {
      var stored = JSON.parse(sessionStorage.getItem('jcb-used-data')) || [];
      var searchResultsContainer = document.getElementById('used-equipment-search-results');

      if (append !== true) {
        searchResultsContainer.innerHTML = '';
        stored = data;
      } else {
        for (var i = 0; i < data.length; i++) stored.push(data[i]);
      }
      sessionStorage.setItem('jcb-used-data', JSON.stringify(stored));

      var usedEquipmentResults = data;

      if (searchResultsContainer) {
        $.each(usedEquipmentResults, function (i, item) {
          var price = item.Price;
          var name = item.Name;
          var url = item.Url;
          var imageUrl = item.MainImageUrl;
          var manufacturer = item.Manufacturer;
          var range = item.Range;
          var hours = item.Hours;
          var year = item.ManufacturerYear;
          var currency = item.Currency;

          var labelCurrency = currency;
          var labelManufacturer = i18n.UsedSearch.manufacturer;
          var labelRange = i18n.UsedSearch.range;
          var labelHours = i18n.UsedSearch.hours;
          var labelYear = i18n.UsedSearch.year;
          var labelViewDetails = i18n.UsedSearch.viewDetails;

          searchResultsContainer.innerHTML +=
            '<div class="used-equipment-results--item col-sm-6 col-lg-4 col-xl-12">' +
            '<div class="product-list" style="">' +
            '<div class="container-fluid">' +
            '<div class="row">' +
            '<div class="col-xl-3">' +
            '<div class="img-wrap" style="background-image:url(' +
            imageUrl +
            ')">' +
            '<img src="' +
            imageUrl +
            '" alt="' +
            name +
            '" loading="lazy">' +
            '</div>' +
            '</div>' +
            '<div class="col-xl-9">' +
            '<div class="row">' +
            '<div class="col-xl-12">' +
            '<div class="row">' +
            '<div class="col-xl-8">' +
            '<div class="editor-content" style="">' +
            ' <h2>' +
            name +
            '</h2>' +
            '</div>' +
            '</div>' +
            '<div class="col-xl-4">' +
            '<div class="product-price-info-wrap">' +
            '<div class="product-price-info-inner">' +
            ' <div class="installment-price-box">' +
            '<span class="price-wrap">' +
            '<span class="item-currency">' +
            labelCurrency +
            '</span><span class="item-price" data-price="' +
            price +
            '">' +
            price +
            '</span>' +
            '</span>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="col-xl-12">' +
            '<div class="row">' +
            '<div class="col-xl-8">' +
            '<div class="product-spec">' +
            '<div class="row">' +
            '<div class="col-6 col-md-3">' +
            '<dl>' +
            '<dt>' +
            labelManufacturer +
            '</dt>' +
            '<dd>' +
            manufacturer +
            '</dd>' +
            '</dl>' +
            '</div>' +
            '<div class="col-6 col-md-4">' +
            '<dl>' +
            '<dt>' +
            labelRange +
            '</dt>' +
            '<dd>' +
            range +
            '</dd>' +
            '</dl>' +
            '</div>' +
            '<div class="col-6 col-md-2">' +
            '<dl>' +
            '<dt>' +
            labelHours +
            '</dt>' +
            '<dd>' +
            hours +
            '</dd>' +
            '</dl>' +
            '</div>' +
            '<div class="col-6 col-md-3">' +
            '<dl>' +
            '<dt>' +
            labelYear +
            '</dt>' +
            '<dd>' +
            year +
            '</dd>' +
            '</dl>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="col-xl-4">' +
            '<a href="' +
            url +
            '" class="jcb-btn-primary">' +
            '<span>' +
            labelViewDetails +
            '</span>' +
            '</a>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
        });
      }

      var total = $('.js--show-more-used-equipments').attr('data-total');
      var current = $('.used-equipment-results--item').length;

      if (current < total) {
        $('.js--show-more-used-equipments').show();
      } else {
        $('.js--show-more-used-equipments').hide();
      }

      $('.js--used-sort-block').show();
      sessionStorage.setItem('jcb-used-data-total', total);
    }

    function scrollToUsedEquipmentResults() {
      if ($('#used-equipment-search-results').length > 0) {
        var $target = $('#js--used-scroll-to')[0];
        $('html, body').animate(
          {
            scrollTop: '+=' + $target.getBoundingClientRect().y,
          },
          700,
          'swing',
        );
      }
    }

    //only run on the page load - restore search results from the saved session data
    function restoreFromSession() {
      var data = [];
      var isPage = $('#used-equipment-search-results').length > 0;
      var savedSessionUrlPath = sessionStorage.getItem('jcb-used-url-path') || null;
      var formFields = [];
      var sortBy = sessionStorage.getItem('jcb-used-sortby');
      var total = sessionStorage.getItem('jcb-used-data-total');

      if (savedSessionUrlPath !== null && savedSessionUrlPath == window.location.pathname) {
        formFields = JSON.parse(sessionStorage.getItem('jcb-used-formfields')) || [];
        data = JSON.parse(sessionStorage.getItem('jcb-used-data')) || [];
      }

      if (isPage && data.length > 0) {
        //set the form fields
        if (formFields && formFields.length > 0) {
          setTimeout(function () {
            for (var x = 0; x < formFields.length; x++) {
              var field = $('[name="' + formFields[x].name + '"]');
              field.val(formFields[x].value).attr('data-is-selected', formFields[x].isSelected);

              if (field.is('select')) {
                var options = formFields[x].options;
                if (options != undefined && options.length > 0) {
                  var defaultOption = undefined;

                  if (formFields[x].value !== '') {
                    defaultOption = formFields[x].value;
                  }
                  populateSelect(field, options, defaultOption);
                }
              }

              if (field.is(':checkbox')) {
                field.attr('checked', formFields[x].value);
              }
            }
          }, 200);
        }
        if (sortBy != null) {
          var order = sortBy.split('/');
          var col = order[0];
          var dir = order[1];
          setTimeout(function () {
            $('.js--used-sortby').val(sortBy).selectmenu('refresh');
          }, 500);
        }
        $('.js--show-more-used-equipments')
          .attr('data-sort-col', col)
          .attr('data-sort-dir', dir)
          .attr('data-total', total);
        renderUsedEquipmentResults(data);
        updateSearchResultValue(total);
        scrollToUsedEquipmentResults();
      } else if (isPage) {
        fetchSelectFilterOptions();
      }
    }

    function resetSortOptions() {
      var sortBy = 'price/asc';
      if (sortBy != null) {
        setTimeout(function () {
          $('.js--used-sortby').val(sortBy).selectmenu('refresh');
        }, 500);
      }
    }

    // hide the load more button by default
    $('.js--show-more-used-equipments').hide();
    $('.js--used-sort-block').hide();

    restoreFromSession();

    window.isTopBarDealer = function (ele) {
      if ($(ele).closest('.dealer--top-bar').length > 0) {
        return true;
      }

      return false;
    };

    window.isMobileMenuOpen = function () {
      if ($('body').is('.menu-open')) {
        return true;
      }
      return false;
    };

    $('.js--dealer-contact').on('click', function () {
      if (window.isMobileMenuOpen()) {
        window.closeMobileMenu();
      }

      if ($(this).is('.active')) {
        window.closeDealerContactModal();
      } else {
        window.openDealerContactModal();
      }
    });

    window.openDealerContactModal = function () {
      setTimeout(function () {
        $('.js--dealer-contact').each(function () {
          $(this).find('.chevron-to-cross').addClass('active');
          $(this).addClass('active');
        });
      }, 100);

      $('.dealer-contact--modal').fadeIn('fast');
    };

    window.closeDealerContactModal = function () {
      setTimeout(function () {
        $('.js--dealer-contact').each(function () {
          $(this).find('.chevron-to-cross').removeClass('active');
          $(this).removeClass('active');
        });
      }, 100);

      $('.dealer-contact--modal').fadeOut('fast');
    };
  }

  (function responsiveTables() {
    const tables = document.querySelectorAll(
      'table.responsive-table, table.responsive-tbl, table.highlighted-column-tbl',
    );
    let headings = [];

    [...tables].forEach(function (table) {
      table.style.cssText = 'opacity: 0; transition: opacity 0.3s ease-in;';
      const th = table.querySelectorAll('th');
      [...th].forEach(function (heading) {
        headings.push(heading.textContent);
      });

      const rows = table.querySelectorAll('tbody > tr');

      [...rows].forEach(function (row) {
        const columns = row.querySelectorAll('td');

        [...columns].forEach(function (column, index) {
          column.setAttribute('data-title', headings[index]);
        });
      });
      setTimeout(function () {
        table.classList.add('visible');
      }, 250);
    });
  })();

  (function numberedTableRows() {
    const tables = document.querySelectorAll('table.numbered-rows-tbl');

    if (tables.length > 0) {
      [...tables].forEach(function (table) {
        const theadRow = table.querySelector('thead tr'),
          blankCol = document.createElement('td'),
          rows = table.querySelectorAll('tbody > tr');

        blankCol.classList.add('row-count');
        theadRow.insertBefore(blankCol, theadRow.children[0]);

        [...rows].forEach(function (row) {
          const countColumn = document.createElement('td'),
            columns = row.querySelectorAll('td');

          countColumn.classList.add('row-count');
          row.insertBefore(countColumn, columns[0]);
        });
      });
    }
  })();
})(jQuery);

(function ($) {
  'use strict';

  /**
   * Scipts for Finance Offers page.
   * Author: Yui Yu
   * Created: 14/08/2019
   * **/
  const iframeStr = "<iframe loading='lazy'";
  const jsFinShowOffer = '.js--fin-show-offer';
  const jsFinRedirect = '.js--fin-redirect';
  const dataFirstOrder = 'data-first-offer';
  const dataFinRedirect = 'data-fin-redirect';

  $(function () {
    $('#finSpanClose').on('click', function (e) {
      e.preventDefault();
      $('#finOfferOverlay').hide();
    });

    const firstOfferBtns = document.querySelectorAll(jsFinShowOffer);
    const redirectBtns = document.querySelectorAll(jsFinRedirect);

    [...firstOfferBtns].forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        const value = e.target.getAttribute(dataFirstOrder);
        let obj = JSON.parse(value);

        if (obj.Title) {
          showFinOffer();
        }
      });

      btn.addEventListener('mouseover', function (e) {
        const value = e.target.getAttribute(dataFirstOrder);
        let obj = JSON.parse(value);

        setFinOfferModal(obj);
      });
    });

    [...redirectBtns].forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const value = e.target.getAttribute(dataFinRedirect);
        redirectUrl(value);
      });
    });
    // repeat with the interval of 2 seconds
    let timerId = setInterval(() => {
      $('h1, p, a, strong, b, em, i, label').each(function () {
        var html = $(this).html();
        if ($(this).children().length == 0 && html.indexOf('no-uppercase') < 0) {
          $(this).html($(this).html().replace(/ß/g, '<span class="no-uppercase">ß</span>'));
        }
      });
    }, 2000);

    // after 5 seconds stop
    setTimeout(() => {
      clearInterval(timerId);
    }, 5000);
  });

  function redirectUrl(url) {
    window.location.href = url;
  }

  function showFinOffer() {
    $('#finOfferOverlay').show();
  }

  function setFinOfferModal(modal) {
    if (modal.Title) {
      $('#finOverTitle').html(modal.Title);
    }

    if (modal.Heading) {
      $('#finOverHeading').html(modal.Heading);
    }

    if (modal.ImageUrl) {
      $('#finOverImage').attr('src', modal.ImageUrl);
    }

    if (modal.OfferUrl) {
      $('#finOverbutton').on('click', function (e) {
        e.preventDefault();
        redirectUrl(modal.OfferUrl);
      });
    }

    if (modal.TermsAndConditions) {
      $('#finTACText').html(modal.TermsAndConditions);
    } else {
      $('#finTACText').html('');
    }

    if (modal.Description) {
      let ar = modal.Description.split(iframeStr);
      $('#finDescText').html(ar[0]);
      if (ar.length > 1) {
        $('#finIFrame').html(iframeStr + ar[1]);
        $('#finIFrame').show();
      } else {
        $('#finIFrame').hide();
      }
    } else {
      $('#finDescText').html('');
    }
  }
  /** END
   * Scipts for Finance Offers page.
   * **/
})(jQuery);
